export function uniqueStandardRefsForSetFromHits(hits, setCode) {
  if (!setCode || !hits || !hits.length) {
    return []
  }

  const refs = new Set()
  hits.forEach(h => {
    h?.standard_set_refs?.forEach(setRef => {
      if (setRef.standard_set_code === setCode) {
        refs.add(setRef.standard_long_ref)
      }
    })
  })

  return Array.from(refs)
}
